module.exports = __webpack_public_path__ + "static/media/zillow-logo.89a32874.png";